/* eslint-disable no-unused-vars */

import View from '../view';
import './index.css';
import { useLink } from 'react-router-stack';
import Constants from '../../constants';
// import useTheme from '../../utilities/hooks/theme';
import SideDrawer from '../../container/dashboard/side_drawer';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setActiveTab } from '../../actions/app-actions-types';
import RadioGroup from '@mui/material/RadioGroup/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel/FormControlLabel';
import Radio from '@mui/material/Radio/Radio';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import { ChangeEvent } from 'react';
import { changeTheme } from '../../actions/setting-actions-types';
import useTheme from '../../utilities/hooks/theme';

const SideBar = () => {
  const navigate = useLink();
  // const { DashboardTheme: theme }: { DashboardTheme: any } = useTheme();
  const { MoreTheme, DashboardTheme: theme } = useTheme();
  const dispatch = useDispatch();
  const setting = useSelector((state: any) => state.setting);
  const { themeType = '' } = setting;

  const { activeSidebarTab: activeTab = 'Home' } = useSelector((state: any) => state.app);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const onPressToggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const onPressIGamioLogo = () => {
    navigate.replace('/');
  };
  const handleNavigation = (item: any) => {
    dispatch(setActiveTab(item.title));
    navigate.push(item.url);
  };
  const radiosSx: SxProps<Theme> = {
    '& .MuiTypography-root': {
      fontSize: 'small',
      fontFamily: 'ProximaNova-Regular',
      color: MoreTheme.editProfileLabel
    }
  };

  const handleRadioChange = (event: ChangeEvent<HTMLInputElement>) => {
    dispatch(changeTheme((event.target as HTMLInputElement).value));
  };
  const sideBarLogoWrapperStyle = {
    backgroundImage: themeType === 'dark' ? theme.dashBoardHeaderBackground : '',
    backgroundColor: themeType !== 'dark' ? theme.dashBoardHeaderBackground : '',
    borderBottom: `2px solid ${theme.dashBoardHeaderSeperatorBg}`
  };

  const sideBarBg = {
    backgroundImage: themeType === 'dark' ? theme.dashBoardSideBarBackground : '',
    backgroundColor: themeType !== 'dark' ? theme.dashBoardSideBarBackground : ''
  };

  const sideBarSectionBg = {
    backgroundColor: theme.sideBarSectionBg
  };
  return (
    <View className="sideBar__wrapper__web" style={sideBarBg}>
      <div className="sideBar__container__web">
        <div className="sidebar_logo_wrapper" style={sideBarLogoWrapperStyle}>
          <View className="dashboard-menu-logo-wrapper" onPress={onPressIGamioLogo}>
            <img
              style={{
                objectFit: 'contain',
                width: '175px'
              }}
              src={Constants.Images.iGamio}
            />
          </View>
        </div>
        <SideDrawer drawerOpen={drawerOpen} onPressToggleDrawer={onPressToggleDrawer} />

        <View className="sideBar__sections" style={sideBarSectionBg}>
          {Constants.SideBar.section1.map((item: any, idx: any) => (
            <div key={idx}>
              <div
                className="sidebar_content_wrapper"
                key={idx}
                onClick={() => handleNavigation(item)}>
                <div
                  className={
                    activeTab === item.title
                      ? 'sidebar_content_logo_active'
                      : 'sidebar_content_logo'
                  }>
                  <img
                    className="sidebar_item_icon"
                    src={activeTab === item.title ? item.activeImgSrc : item.imgSrc}
                  />
                </div>
                <div
                  className={
                    activeTab === item.title
                      ? 'sidebar_content_name_active'
                      : 'sidebar_content_name'
                  }>
                  {item.title}
                </div>
              </div>
            </div>
          ))}
        </View>
        <View className="sideBar__sections" style={sideBarSectionBg}>
          {Constants.SideBar.section2.map((item: any, idx: any) => (
            <div key={idx}>
              <div
                className="sidebar_content_wrapper"
                key={idx}
                onClick={() => handleNavigation(item)}>
                <div
                  className={
                    activeTab === item.title
                      ? 'sidebar_content_logo_active'
                      : 'sidebar_content_logo'
                  }>
                  <img
                    className="sidebar_item_icon"
                    src={activeTab === item.title ? item.activeImgSrc : item.imgSrc}
                  />
                </div>
                <div
                  className={
                    activeTab === item.title
                      ? 'sidebar_content_name_active'
                      : 'sidebar_content_name'
                  }>
                  {item.title}
                </div>
              </div>
            </div>
          ))}
        </View>
        {/* <div className="sidebar_seperator"></div> */}

        {/* <RadioGroup
          sx={radiosSx}
          style={{ ...sideBarSectionBg, padding: '15px' }}
          defaultValue="light"
          row
          className={'sideBar__sections'}
          value={themeType.toLowerCase()}
          onChange={handleRadioChange}>
          <FormControlLabel value="light" control={<Radio />} label="Light" />
          <FormControlLabel value="dark" control={<Radio />} label="Dark" />
        </RadioGroup> */}
      </div>
    </View>
  );
};

export default SideBar;
